/**
 * MyPiggy safe diagnostics. Only fixed event names and allowlisted scalar
 * metadata are accepted. Never pass user/profile/session/error objects here.
 * No client-side transport: central collection requires separate privacy review.
 */
const SAFE_FIELDS = new Set(['platform', 'environment', 'app_version', 'error_code', 'duration_ms', 'status', 'operation']);
const SAFE_EVENT = /^[a-z][a-z0-9_.-]{2,79}$/;
const SAFE_VALUE = /^[A-Za-z0-9_.-]{1,80}$/;
const IS_DEV = import.meta.env.DEV;

export const diagnostic = (level, event, metadata = {}) => {
  if (!SAFE_EVENT.test(event)) return;
  if (!['debug', 'info', 'warn', 'error'].includes(level)) return;
  if (!IS_DEV && (level === 'debug' || level === 'info')) return;

  const details = {};
  for (const [key, value] of Object.entries(metadata)) {
    if (!SAFE_FIELDS.has(key)) continue;
    if (key === 'duration_ms') {
      if (Number.isFinite(value) && value >= 0) details[key] = Math.round(value);
    } else if (typeof value === 'string' && SAFE_VALUE.test(value)) {
      details[key] = value;
    }
  }
  // A single, already allowlisted string remains readable in Android Logcat.
  // Never stringify exceptions, sessions, URLs, or arbitrary caller objects.
  const output = `[MyPiggy] ${JSON.stringify({ event, ...details })}`;
  if (level === 'error') console.error(output);
  else if (level === 'warn') console.warn(output);
  else if (IS_DEV) console.debug(output);
};
